"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ = require("./..");
var _styles = require("../../styles");
var _fa = require("react-icons/fa");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BackToTop = _ref => {
  let {
    showAlways
  } = _ref;
  const theme = (0, _styles.useTheme)();
  const [visible, setVisible] = (0, _react.useState)(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 0 || showAlways) {
      setVisible(true);
    } else if (scrolled <= 0) {
      setVisible(false);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  window.addEventListener('scroll', toggleVisible);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Button, {
    variant: "outlined",
    color: "primary",
    onClick: scrollToTop,
    "aria-label": "Back to Top",
    title: "Back to Top",
    style: {
      display: visible || showAlways ? 'inline' : 'none'
    },
    sx: {
      borderRadius: 2,
      minWidth: 'auto',
      width: '30px',
      height: '30px',
      padding: 0.5,
      borderColor: (0, _styles.alpha)(theme.palette.divider, 0.2)
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fa.FaChevronUp, {})
  });
};
BackToTop.propTypes = {
  /**
   * Overrides only showing the button when user has scrolled a bit.
   */
  showAlways: _propTypes.default.bool
};
BackToTop.defaultProps = {
  showAlways: false
};
var _default = exports.default = BackToTop;